import { flow } from 'lodash';

import { NAME } from './slips.constant';

const selectStateKey = (state) => state[NAME];

export const selectState = flow(selectStateKey);
